<div class="container">
  <div class="loading" *ngIf="isUploading || isLoading">
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="32" color="accent"></mat-progress-spinner>
    <span *ngIf="isUploading">{{ uploadingMessageKey | translate }}</span>
    <span *ngIf="isLoading && !isUploading">{{ 'studies.cards.loading' | translate }}</span>

    <div class="transfer-failed-alert" *ngIf="isTransferFailed">
      <span class="alert-message">
        {{ 'studies.cards.transfer_failed_help_before' | translate }}
        <mat-icon class="more-icon">more_vert</mat-icon>
        {{ 'studies.cards.transfer_failed_help_after' | translate }}
      </span>
    </div>
  </div>
  <canvas #canvas></canvas>
  <img #img
    [class.hidden]="!resolved"
    alt="Card preview image"
    (load)="isLoading = false"
    *ngIf="!shouldLazyLoad">
  <img [appLazyLoadImage]="url"
    [lazyLoadPlaceholder]="placeholderUrl"
    [lazyLoadThreshold]="200"
    [class.hidden]="!resolved"
    alt="Card preview image"
    (imageLoaded)="isLoading = false"
    (imageError)="isLoading = false"
    *ngIf="shouldLazyLoad">
</div>
